module.exports = __webpack_public_path__ + "static/media/left-mountains.b274e53b.svg";